import React from 'react';

interface HomePageTickerProps {
  children: React.ReactNode;
  speed?: 'slow' | 'normal' | 'fast';
  className?: string;
}

export default function HomePageTicker({
  children,
  speed = 'normal',
  className = '',
}: HomePageTickerProps) {
  const speedMap = {
    slow: 'animate-[ticker_30s_linear_infinite]',
    normal: 'animate-ticker',
    fast: 'animate-[ticker_10s_linear_infinite]',
  };

  // Handle single child by creating multiple copies
  const content =
    React.Children.count(children) === 1
      ? Array.from({ length: 8 }, (_, index) => (
          <React.Fragment key={index}>{children}</React.Fragment>
        ))
      : children;

  return (
    <div className='relative overflow-hidden bg-white'>
      <div className={`inline-flex whitespace-nowrap ${speedMap[speed]}`}>
        <div className={`flex items-center ${className}`}>{content}</div>
        <div className={`flex items-center ${className}`}>{content}</div>
      </div>
    </div>
  );
}
